// juno/ai-engine/index.ts
import CassetteAI from "./CassetteAI.png";
import CassetteAIsfx from "./CassetteAIsfx.png";
import DiffRhythm from "./DiffRhythm.png";
import ElevenLabs from "./ElevenLabs.png";
import MinimaxAudio from "./MinimaxAudio.png";
import MmAudio from "./MMAudio.png";
import ACE_STEP from "./ACE_STEP.png";
import ACE_STEP_PROMPT_TO_AUDIO from "./ACE_STEP_PROMPT_TO_AUDIO.png";
import AuraSR from "./AuraSR.png";
import BriaBackgroundReplace from "./BriaBackgroundReplace.png";
import BriaProductShot from "./BriaProductShot.png";
import ClarityUpscaler from "./ClarityUpscaler.png";
import CreativeUpscaler from "./CreativeUpscaler.png";
import DallE3 from "./DallE3.png";
import Flux1Dev from "./Flux1Dev.png";
import Flux1DevCannyLoRA from "./Flux1DevCannyLoRA.png";
import Flux1DevDepthLoRA from "./Flux1DevDepthLoRA.png";
import Flux1DevFill from "./Flux1DevFill.png";
import Flux1DevRedux from "./Flux1DevRedux.png";
import Flux1Pro from "./Flux1Pro.png";
import Flux1ProCanny from "./Flux1ProCanny.png";
import Flux1ProCannyJuno from "./Flux1ProCannyJuno.png";
import Flux1ProDepth from "./Flux1ProDepth.png";
import Flux1ProDepthJuno from "./Flux1ProDepthJuno.png";
import Flux1ProFill from "./Flux1ProFill.png";
import Flux1ProFillJuno from "./Flux1ProFillJuno.png";
import Flux1ProJuno from "./Flux1ProJuno.png";
import Flux1RealismLoRA from "./Flux1RealismLoRA.png";
import Flux1Schnell from "./Flux1Schnell.png";
import Flux1SchnellRedux from "./Flux1SchnellRedux.png";
import Flux11Pro from "./Flux11Pro.png";
import Flux11ProRedux from "./Flux11ProRedux.png";
import Flux11ProUltra from "./Flux11ProUltra.png";
import Flux11ProUltraJuno from "./Flux11ProUltraJuno.png";
import Flux11ProUltraRedux from "./Flux11ProUltraRedux.png";
import FluxJuggernautBase from "./FluxJuggernautBase.png";
import FluxJuggernautJuno from "./FluxJuggernautJuno.png";
import FluxJuggernautLightning from "./FluxJuggernautLightning.png";
import FluxJuggernautPro from "./FluxJuggernautPro.png";
import FluxJuno from "./FluxJuno.png";
import FluxPuLID from "./FluxPuLID.png";
import FluxProKontext from "./FluxProKontext.png";
import FluxProKontextMax from "./FluxProKontextMax.png";
import GeminiFlashEdit from "./GeminiFlashEdit.png";
import IcLightV2 from "./IcLightV2.png";
import Imagen3 from "./Imagen3.png";
import Imagen4 from "./Imagen4.png";
import InstantCharacter from "./InstantCharacter.png";
import KolorsVTO from "./KolorsVTO.png";
import LuminaV2 from "./LuminaV2.png";
import Lyria2 from "./Lyria2.png";
import MinimaxImage from "./MinimaxImage.png";
import RecraftCrispUpscaler from "./RecraftCrispUpscaler.png";
import RecraftCreativeUpscaler from "./RecraftCreativeUpscaler.png";
import RecraftV3 from "./RecraftV3.png";
import SD from "./SD.png";
import SD3 from "./SD3.png";
import SD35 from "./SD35.png";
import SDUltra from "./SDUltra.png";
import SDXL from "./SDXL.png";
import Ghiblify from "./Ghiblify.png";
import SanaSprint from "./SanaSprint.png";
import Sana48B from "./Sana48B.png";
import GPTImage1 from "./GPTImage1.png";
import IdeogramV3 from "./IdeogramV3.png";
import IdeogramV3Remix from "./IdeogramV3Remix.png";
import IdeogramV3Edit from "./IdeogramV3Edit.png";
import IdeogramV3ReplaceBackground from "./IdeogramV3ReplaceBackground.png";

const JunoAiEngine = {
  CassetteAI,
  CassetteAIsfx,
  DiffRhythm,
  ElevenLabs,
  MinimaxAudio,
  MmAudio,
  ACE_STEP,
  ACE_STEP_PROMPT_TO_AUDIO,
  AuraSR,
  BriaBackgroundReplace,
  BriaProductShot,
  ClarityUpscaler,
  CreativeUpscaler,
  DallE3,
  Flux1Dev,
  Flux1DevCannyLoRA,
  Flux1DevDepthLoRA,
  Flux1DevFill,
  Flux1DevRedux,
  Flux1Pro,
  Flux1ProCanny,
  Flux1ProCannyJuno,
  Flux1ProDepth,
  Flux1ProDepthJuno,
  Flux1ProFill,
  Flux1ProFillJuno,
  Flux1ProJuno,
  Flux1RealismLoRA,
  Flux1Schnell,
  Flux1SchnellRedux,
  Flux11Pro,
  Flux11ProRedux,
  Flux11ProUltra,
  Flux11ProUltraJuno,
  Flux11ProUltraRedux,
  FluxJuggernautBase,
  FluxJuggernautJuno,
  FluxJuggernautLightning,
  FluxJuggernautPro,
  FluxJuno,
  FluxPuLID,
  FluxProKontext,
  FluxProKontextMax,
  GeminiFlashEdit,
  IcLightV2,
  Imagen3,
  Imagen4,
  InstantCharacter,
  KolorsVTO,
  LuminaV2,
  Lyria2,
  MinimaxImage,
  RecraftCrispUpscaler,
  RecraftCreativeUpscaler,
  RecraftV3,
  SD,
  SD3,
  SD35,
  SDUltra,
  SDXL,
  Ghiblify,
  SanaSprint,
  Sana48B,
  GPTImage1,
  IdeogramV3,
  IdeogramV3Remix,
  IdeogramV3Edit,
  IdeogramV3ReplaceBackground,
};

export default JunoAiEngine;

// 個別エクスポート
export {
  CassetteAI as junoAiEngineCassetteAI,
  CassetteAIsfx as junoAiEngineCassetteAIsfx,
  DiffRhythm as junoAiEngineDiffRhythm,
  ElevenLabs as junoAiEngineElevenLabs,
  MinimaxAudio as junoAiEngineMinimaxAudio,
  MmAudio as junoAiEngineMmAudio,
  ACE_STEP as junoAiEngineACE_STEP,
  ACE_STEP_PROMPT_TO_AUDIO as junoAiEngineACE_STEP_PROMPT_TO_AUDIO,
  AuraSR as junoAiEngineAuraSR,
  BriaBackgroundReplace as junoAiEngineBriaBackgroundReplace,
  BriaProductShot as junoAiEngineBriaProductShot,
  ClarityUpscaler as junoAiEngineClarityUpscaler,
  CreativeUpscaler as junoAiEngineCreativeUpscaler,
  DallE3 as junoAiEngineDallE3,
  Flux1Dev as junoAiEngineFlux1Dev,
  Flux1DevCannyLoRA as junoAiEngineFlux1DevCannyLoRA,
  Flux1DevDepthLoRA as junoAiEngineFlux1DevDepthLoRA,
  Flux1DevFill as junoAiEngineFlux1DevFill,
  Flux1DevRedux as junoAiEngineFlux1DevRedux,
  Flux1Pro as junoAiEngineFlux1Pro,
  Flux1ProCanny as junoAiEngineFlux1ProCanny,
  Flux1ProCannyJuno as junoAiEngineFlux1ProCannyJuno,
  Flux1ProDepth as junoAiEngineFlux1ProDepth,
  Flux1ProDepthJuno as junoAiEngineFlux1ProDepthJuno,
  Flux1ProFill as junoAiEngineFlux1ProFill,
  Flux1ProFillJuno as junoAiEngineFlux1ProFillJuno,
  Flux1ProJuno as junoAiEngineFlux1ProJuno,
  Flux1RealismLoRA as junoAiEngineFlux1RealismLoRA,
  Flux1Schnell as junoAiEngineFlux1Schnell,
  Flux1SchnellRedux as junoAiEngineFlux1SchnellRedux,
  Flux11Pro as junoAiEngineFlux11Pro,
  Flux11ProRedux as junoAiEngineFlux11ProRedux,
  Flux11ProUltra as junoAiEngineFlux11ProUltra,
  Flux11ProUltraJuno as junoAiEngineFlux11ProUltraJuno,
  Flux11ProUltraRedux as junoAiEngineFlux11ProUltraRedux,
  FluxJuggernautBase as junoAiEngineFluxJuggernautBase,
  FluxJuggernautJuno as junoAiEngineFluxJuggernautJuno,
  FluxJuggernautLightning as junoAiEngineFluxJuggernautLightning,
  FluxJuggernautPro as junoAiEngineFluxJuggernautPro,
  FluxJuno as junoAiEngineFluxJuno,
  FluxPuLID as junoAiEngineFluxPuLID,
  FluxProKontext as junoAiEngineFluxProKontext,
  FluxProKontextMax as junoAiEngineFluxProKontextMax,
  GeminiFlashEdit as junoAiEngineGeminiFlashEdit,
  IcLightV2 as junoAiEngineIcLightV2,
  Imagen3 as junoAiEngineImagen3,
  Imagen4 as junoAiEngineImagen4,
  InstantCharacter as junoAiEngineInstantCharacter,
  KolorsVTO as junoAiEngineKolorsVTO,
  LuminaV2 as junoAiEngineLuminaV2,
  Lyria2 as junoAiEngineLyria2,
  MinimaxImage as junoAiEngineMinimaxImage,
  RecraftCrispUpscaler as junoAiEngineRecraftCrispUpscaler,
  RecraftCreativeUpscaler as junoAiEngineRecraftCreativeUpscaler,
  RecraftV3 as junoAiEngineRecraftV3,
  SD as junoAiEngineSD,
  SD3 as junoAiEngineSD3,
  SD35 as junoAiEngineSD35,
  SDUltra as junoAiEngineSDUltra,
  SDXL as junoAiEngineSDXL,
  Ghiblify as junoAiEngineGhiblify,
  SanaSprint as junoAiEngineSanaSprint,
  Sana48B as junoAiEngineSana48B,
  GPTImage1 as junoAiEngineGPTImage1,
};
